"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStatus = exports.FormTypes = void 0;
var FormTypes;
(function (FormTypes) {
    FormTypes["idr"] = "idr";
    FormTypes["consolidation"] = "consolidation";
    FormTypes["pslf"] = "pslf";
})(FormTypes || (exports.FormTypes = FormTypes = {}));
var FormStatus;
(function (FormStatus) {
    FormStatus["STARTED"] = "started";
    FormStatus["COMPLETED"] = "completed";
    FormStatus["SIGNED"] = "signed";
    FormStatus["REJECTED"] = "rejected";
    FormStatus["PROCESSED"] = "processed";
    FormStatus["CANCELLED"] = "cancelled";
    FormStatus["EXPIRED"] = "expired";
})(FormStatus || (exports.FormStatus = FormStatus = {}));
//# sourceMappingURL=forms.js.map